let mapConfig = {}
initConfigData()

function initConfigData(){
  mapConfig = {
    gisType: "td",
    tk: "acce4aec9b652c2a2c24a20fcfa78285",
    ak: "V2Knz5rHQrptKcOB8dLtjrPBUI5b0Bk6",
    wkid: "4326",
    center: [116.39145035352216,39.906659900588416],
    minZoom: 5,
    maxZoom: 16,
    zoom: 12,
    baseLayerOptsTD: {
      renderer: 'canvas',
      urlTemplate: "http://t{s}.tianditu.gov.cn/vec_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=vec&STYLE=black&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=acce4aec9b652c2a2c24a20fcfa78285",
      subdomains: ['1', '2', '3', '4', '5', '6', '7'],
      visible: true,
      opacity: 1,
    },
    layerOptsTD: [
      {
        renderer: 'canvas',
        urlTemplate: "http://t{s}.tianditu.gov.cn/cva_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cva&STYLE=black&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=acce4aec9b652c2a2c24a20fcfa78285",
        subdomains: ['1', '2', '3', '4', '5', '6', '7'],
        visible: true,
        opacity: 1,
      }
    ],
    baseLayerOptsBD: {
      //label:"BD_Map_VEC",
      renderer: 'canvas',
      urlTemplate: "https://gss{s}.bdstatic.com/8bo_dTSlRsgBo1vgoIiO_jowehsv/tile/?qt=tile&x={x}&y={y}&z={z}&styles=pl&scaler=1&udt=20170927",
      subdomains: [0, 1, 2, 3],
      tileSystem: [1, 1, 0, 0],
      visible: true,
      opacity: 1,
    },
    layerOptsBD: [],
    scaleControl: {
      position: 'bottom-left',
      maxWidth: 100,
      metric: true,
      imperial: false
    },
    tdApiAddr: "http://api.tianditu.gov.cn/geocoder?tk=",
    bdApiAddr: 'https://api.map.baidu.com/reverse_geocoding/v3/?output=json&ak=',
    tdApiUrl: "",
    bdApiUrl: ""
  }
  mapConfig.tdApiUrl = mapConfig.tdApiAddr + mapConfig.tk
  mapConfig.bdApiUrl = mapConfig.bdApiAddr + mapConfig.ak
}

let moduleConfig = []

export {mapConfig, moduleConfig, initConfigData}



// WEBPACK FOOTER //
// ./src/components/EXGis/gisConfig.js